
export default [
	{
		path: '/admin/occupations',
		name: 'occupation',
		meta: { requiresAuth: true },
		component: () => import('@/pages/credit-operation/occupation')
	}
]
